export default "__VITE_ASSET__DdZgI8QZ__"